export var ZERO_WIDTH_SPACE = "\u200B";
export var ZERO_WIDTH_JOINER = "\u200D";